module.exports = __webpack_public_path__ + "img/glassquality_6.1b728641.png";